import './LoginRegisterPopup.css';
import React from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import IconClosePrimary from '../../components/atoms/Icons/IconClosePrimary';
import RouterLink from '../atoms/RouterLink';
import { canUseDOM, getGlobalDictionaryTerm } from '../../utils';
import Cookies from 'js-cookie';
import { get, getDictionaryItem } from '../../utils';
const LoginRegisterPopup = _ref => {
  let {
    dictionary,
    accountLinks,
    videoPopup
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const [loginLinkState, setLoginLinkState] = React.useState('');
  const [registerLinkState, setRegisterLinkState] = React.useState('');
  const loginPopupCookieName = 'login_popup';
  const linksArray = get(accountLinks, 'targetItem.links');
  const Login = linksArray && linksArray[2];
  const Register = linksArray && linksArray[4];
  // const dictionaryValues: any = { dictionaryValues: [...dictionary] };
  const popupHeading = videoPopup ? getDictionaryItem(dictionary && dictionary.dictionary, 'LoginVideoPopupTitle') : getDictionaryItem(dictionary && dictionary.dictionary, 'LoginPopupTitle');
  const popupCopy = videoPopup ? getDictionaryItem(dictionary && dictionary.dictionary, 'LoginVideoPopupDetails') : getDictionaryItem(dictionary && dictionary.dictionary, 'LoginDetails');
  const popupLoginTitle = videoPopup ? getDictionaryItem(dictionary && dictionary.dictionary, 'LoginVideoPopupButtonTitle') : get(Login, 'title.jss.value');
  const popupRegisterTitle = videoPopup ? getDictionaryItem(dictionary && dictionary.dictionary, 'LoginVideoPopupRegisterButtonTitle') : get(Register, 'title.jss.value');
  const closeText = getGlobalDictionaryTerm(sitecoreContext, 'close') || "Close";
  const [loginAccessibleTitle, setLoginAccessibleTitle] = React.useState(popupLoginTitle);
  const [registerAccessibleTitle, setRegisterAccessibleTitle] = React.useState(popupRegisterTitle);
  const processClick = () => {
    if (canUseDOM) {
      document.body.classList.remove('lr-popup--open');
      document.body.classList.remove('lr-popup--video--open');
    }
    Cookies.set(loginPopupCookieName, JSON.stringify({
      processed: 'true'
    }), {
      expires: 999,
      secure: true
    });
  };
  React.useEffect(() => {
    let referBackUrl = '';
    if (canUseDOM) {
      referBackUrl = window.location.href;
      if (referBackUrl.indexOf('?') !== -1) {
        referBackUrl = referBackUrl.substr(0, referBackUrl.indexOf('?'));
      }
    }
    const loginLink = get(Login, 'link.jss.value.href') + `?redirect_url=${referBackUrl}`;
    const registerLink = get(Register, 'link.jss.value.href') + `?redirect_url=${referBackUrl}`;
    setLoginLinkState(loginLink);
    setRegisterLinkState(registerLink);
    if (canUseDOM) {}
    setLoginAccessibleTitle(`${popupLoginTitle} - ${referBackUrl}`);
    setRegisterAccessibleTitle(`${popupRegisterTitle} - ${referBackUrl}`);
  }, []);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: `rs_skip ${videoPopup ? 'lr-popup--video' : 'lr-popup'}`
  }, /*#__PURE__*/React.createElement("button", {
    className: "lr-popup__close btn--reset",
    onClick: processClick,
    "aria-label": closeText
  }, /*#__PURE__*/React.createElement("span", {
    hidden: true
  }, closeText), /*#__PURE__*/React.createElement(IconClosePrimary, null)), popupHeading && /*#__PURE__*/React.createElement("h2", {
    className: "h4 lr-popup__title"
  }, popupHeading), /*#__PURE__*/React.createElement("p", {
    className: "body-medium lr-popup__copy"
  }, popupCopy), !!popupLoginTitle && /*#__PURE__*/React.createElement(RouterLink, {
    ariaLabel: loginAccessibleTitle,
    className: "btn btn-primary",
    href: loginLinkState,
    onClick: processClick
  }, popupLoginTitle), !!popupRegisterTitle && /*#__PURE__*/React.createElement(RouterLink, {
    ariaLabel: registerAccessibleTitle,
    className: "btn btn-secondary",
    href: registerLinkState,
    onClick: processClick
  }, popupRegisterTitle)));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: ` ${rtl ? rtlStyles : ltrStyles} ${commonStyles}`
  }, children);
};
const commonStyles = "c55dpy1";
const ltrStyles = "lp94ygm";
const rtlStyles = "r6d6a80";
export default LoginRegisterPopup;